export const keyExtractor = (row, dataName?: string) => {
  return dataName ? (row?.[dataName] ?? row) : row
}
